import React from 'react';
import { Box, Button, DialogContentText, ErrorStateInfo, Typography } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useTranslation } from 'react-i18next';

const FileProcessingError = ({ url, classes }: { url: string; classes: any }) => {
  const { t } = useTranslation();

  const downloadErrorsFileHandler = () => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  return (
    <Box>
      <DialogContentText>
        {t('exam->>ExamConfiguration.UploadCandidateListDescriptionProcessingError')}
      </DialogContentText>

      <Box className={classes.fileProcessingErrorSection}>
        <Box className={`${classes.uploadErrorSection} ${classes.fileProcessingErrorSpacing}`}>
          <ErrorStateInfo>
            <Typography variant="body1" className={classes.uploadErrorDescription}>
              {t('exam->>UploadExcelTemplate.StartFileProcessingErrorDescription')}
            </Typography>
          </ErrorStateInfo>
        </Box>

        <Button variant="text" onClick={downloadErrorsFileHandler} color="primary">
          <IconWithLabel
            iconName={IconName.download}
            iconSize="L"
            label={t('exam->>UploadExcelTemplate.DownloadErrorsFile')}
            typographyProps={{
              variant: 'h5',
              color: 'inherit',
            }}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default FileProcessingError;
